import React from 'react';

const collapsed:boolean = localStorage.getItem('layoutData')
    ? JSON.parse( localStorage.getItem('layoutData') + '' ).collapsed
    : false;

export interface LayoutDispatcher{
    type?:'COLLAPSED' | 'IS_SMALL_SCREEN',
    payload?: LayoutPayload
}

export interface LayoutPayload {
    collapsed?:     boolean
    isSmallScreen?: boolean
}

export const initialState:LayoutPayload = {
    collapsed,
    isSmallScreen: undefined
};

export const LayoutReducer: React.Reducer<LayoutPayload, LayoutDispatcher> = (initialState: LayoutPayload, action: LayoutDispatcher): LayoutPayload => {
    const data = {...initialState};
    switch (action.type) {
        case 'COLLAPSED':
            data.collapsed = !initialState.collapsed;
            break;

        case 'IS_SMALL_SCREEN':
            data.isSmallScreen = action.payload?.isSmallScreen;
            break;

        default:
            console.log('No implementado');
            break;
    }

    localStorage.setItem('layoutData', JSON.stringify(data));
    return data;
};
